<template>
  <div class="view view-curso">
    <top-bar v-if="isPortalReady" />

    <header class="banner" v-for="(curso, i) in cursos" :key="curso.id">
      <div
        class="container"
        :class="{
                        'container-has-video': curso.isLoaded && curso.isPlayerVisible,
                        'banner-content-hidden': !curso.isHovered
                    }"
      >
        <div
          class="container-video"
          :id="'container-video-' + curso.id"
          :style="{
                            backgroundImage: curso.foto == '' ? 'url(' + (curso.foto.includes('/fl_lossy/')) ? curso.foto : curso.foto.replace('upload', 'upload/fl_lossy').replace('http:', 'https:')+ ')' : 'none'
                        }"
          @mouseover="toggleHover(curso, true)"
          @mouseleave="toggleHover(curso, false, 1000)"
        >
          <img
            v-show="!curso.isLoaded"
            :src="require('@/assets/galerias/foto_generica.jpg')"
          />

          <div
            :id="'home-banner-video-' + curso.id"
            class="home-banner-video"
            :class="{
                                'banner-content-hidden': !curso.isPlayerVisible
                            }"
            @click="pauseVideo(i)"
          ></div>

          <div class="banner-content-video-movil">
            <div
              class="banner-video-controls mostrar-movil"
              style="
                                    margin: auto;
                                    padding-bottom: 80px;"
              v-if="curso.playerIndex !== false && (curso.isLoaded || !curso.isLoaded)"
            >
              <button class="bg-trans" @click="pauseVideo(i, false, $event)">
                <img
                  :src="curso.isPlaying ? require('@/assets/images/pause.svg') : require('@/assets/images/play.svg')"
                  class="banner-video-play"
                  :alt="curso.isPlaying ? 'Pausar' : 'Reproducir'"
                />
              </button>
              <button class="bg-trans" @click="replay(curso)">
                <img
                  :src="require('@/assets/images/reload.svg')"
                  class="banner-video-replay"
                  alt="Reiniciar"
                />
              </button>
              <button class="bg-trans" @click="toggleMute(curso)">
                <img
                  :src="!curso.isMuted ? require('@/assets/images/volume-up.svg') : require('@/assets/images/volume-off.svg')"
                  class="banner-video-mute"
                  :alt="curso.isMuted ? 'Escuchar' : 'Silenciar'"
                />
              </button>
            </div>
          </div>

          <div class="banner-content">
            <h1 v-html="curso.autor"></h1>
            <h3>
              Te enseña
              <span v-html="curso.categoria"></span>
            </h3>
            <div v-if="productoAsociado">
              <div v-if="!tieneCurso" class="banner-comprar">
                <button class="btn banner-button btn-radius btn-primary mr-10" @click="comprar">
                  <img :src="require('@/assets/images/icon-bag.svg')" class="btn-icon" />
                  Comprar
                </button>
                <!--<button class="btn banner-button btn-radius botonRegalo" @click="regalar">
                  <img
                    src="https://res.cloudinary.com/dmx3pf3os/image/upload/v1544814102/gift.png"
                    class="btn-icon"
                  />
                  Regalar
                </button>-->
                <span
                  class="banner-precio ocultar-movil"
                >{{ formatCurrency(productoAsociado.precio) }}</span>
              </div>
              <div v-else class="banner-comprar">
                <button
                  class="btn banner-button btn-radius mr-10 curso-banner-play"
                  @click="nextVideo"
                >
                  <img :src="require('@/assets/images/play.svg')" class="btn-icon" />
                  {{ getTipoProgreso().tipo }}
                </button>
                <!--<button class="btn banner-button btn-radius botonRegalo" @click="regalar">
                  <img
                    src="https://res.cloudinary.com/dmx3pf3os/image/upload/v1544814102/gift.png"
                    class="btn-icon"
                  />
                  Regalar
                </button>-->
              </div>
            </div>

            <h3
              v-if="!tieneCurso"
              class="banner-precio mostrar-movil"
              style="text-align: center;margin-top: 1%;"
            >{{ formatCurrency(productoAsociado.precio) }}</h3>

            <div
              class="banner-video-controls ocultar-movil"
              v-if="curso.playerIndex !== false && (curso.isLoaded || !curso.isLoaded)"
            >
              <button class="bg-trans" @click="pauseVideo(i, false, $event)">
                <img
                  :src="curso.isPlaying ? require('@/assets/images/pause.svg') : require('@/assets/images/play.svg')"
                  class="banner-video-play"
                  :alt="curso.isPlaying ? 'Pausar' : 'Reproducir'"
                />
              </button>
              <button class="bg-trans" @click="replay(curso)">
                <img
                  :src="require('@/assets/images/reload.svg')"
                  class="banner-video-replay"
                  alt="Reiniciar"
                />
              </button>
              <button class="bg-trans" @click="toggleMute(curso)">
                <img
                  :src="!curso.isMuted ? require('@/assets/images/volume-up.svg') : require('@/assets/images/volume-off.svg')"
                  class="banner-video-mute"
                  :alt="curso.isMuted ? 'Escuchar' : 'Silenciar'"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="curso-clases">
      <header class="curso-clases-header">
        <div class="container">
          <h3 class="curso-clases-titulo-contenido">¿Qué aprenderás en este curso?</h3>
          <div class="curso-clases-descripcion text-justify" v-html="curso.descripcion"></div>
        </div>
      </header>
      <contenido-list
        v-if="curso.id != 0"
        :contenidos="curso.contenidos"
        :tieneCurso="tieneCurso"
        :registrado="this.user.id"
        :NoAvailable="false"
      />
      <div v-else>
        <div class="curso-loading">
          <spinner />
        </div>
      </div>
    </div>

    <site-footer v-if="isPortalReady" :verFooter="true" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import Carousel from "../components/Carousel";
import TopBar from "../components/TopBar";
import CursoList from "../components/CursoList";
import SiteFooter from "../components/SiteFooter";
import ContenidoList from "../components/ContenidoList";
import Spinner from "../components/Spinner";
import {
  getProductoDeCategoria,
  userTieneProducto,
  getProgresoVideo,
  getDuracionVideo
} from "../utilities/data";
import { wait } from "../utilities/util";

import numeral from "numeral";
import "numeral/locales";

numeral.locale("es");

export default {
  props: ["guid"],
  components: {
    TopBar,
    CursoList,
    SiteFooter,
    Spinner,
    ContenidoList,
    Carousel
  },
  head: {
    title() {
      return {
        inner: this.curso.categoria
      };
    }
  },
  data() {
    return {
      isLoadingContenido: false,
      didLoadContenidos: false,
      cursos: [],
      videosLoaded: false,
      playerRetryCount: 0
    };
  },
  computed: {
    curso() {
      // Devolver el curso y reemplazar los videos del portal por los del usuario (si esta logueado)
      if (this.portal.categorias) {
        return (
          this.portal.categorias.find(cat => cat.guid == this.guid) || { id: 0 }
        );
      }
      return { id: 0, contenidos: [] };
    },
    comprado() {
      let ret = false;
      // buscar en sus compras
      ["mis_compras", "mis_compras_moviles", "mis_regalos"].forEach(compras => {
        if (this.user.hasOwnProperty(compras)) {
          this.user[compras].forEach(compra => {
            compra.detalles_compras.compras_productos.forEach(producto => {
              if (producto.id_producto == this.productoAsociado.id) ret = true;
            });
          });
        }
      });

      return ret;
    },
    productoAsociado() {
      return this.portal.productos_portal && this.curso.id != 0
        ? getProductoDeCategoria(this.portal, this.curso.id)
        : false;
    },
    tieneCurso() {
      if (this.user.all_access_active == 1) return true;
      if (!this.productoAsociado) return false;
      if (this.user.id == 0) return false;
      return userTieneProducto(this.user, this.productoAsociado.id);
    },
    didLoadUser() {
      if ("didLoadUser" in this.site) return this.site.didLoadUser;
      return false;
    },
    ...mapState(["portal", "user", "isPortalReady", "site"]),
    ...mapGetters(["userId"])
  },
  watch: {
    didLoadUser(val, old) {
      if (val && !this.didLoadContenidos) this.loadContenidos();
    },
    isPortalReady(val, old) {
      if (val && !old && this.videosLoaded) {
        this.loadcursos();
      }
    }
  },
  methods: {
    /**
     * Carga un jwplayer por cada banner que tenga video.
     */
    loadPlayer(banner) {
      // Esperar que el player este disponible
      if (
        typeof window.jwplayer === "undefined" ||
        document.querySelector("#home-banner-video-" + banner.id) == null
      ) {
        if (this.playerRetryCount < 10) {
          this.playerRetryCount++;
          return wait(() => {
            this.loadPlayer(banner);
          }, 900);
        } else if (this.contadorWait == 10) {
          console.log("ERROR AL CARGAR SCRIPT");
        }
      }

      if (banner.fuente_video.length) {
        this.$api
          .getPlayerEmbed("media", banner.fuente_video[0].video)
          .then(response => {
            let player = JSON.parse(response.data.player);
            if ("message" in player) return false;

            let sources = player[0].playlist[0].sources;
            // Buscar el tamaño más grande para calcular el alto.
            let ref = sources.reduce(
              (prev, item) => {
                if (
                  item.hasOwnProperty("width") &&
                  item.hasOwnProperty("height")
                )
                  if (item.width > prev.width) return item;

                return prev;
              },
              {
                width: 0,
                height: 0
              }
            );

            let videoSize = this.getVideoSize(banner, ref);

            let jwplayer = window
              .jwplayer("home-banner-video-" + banner.id)
              .setup({
                file: sources[0].file,
                // width: videoSize.width,
                // height: videoSize.height,
                width: "100%",
                height: "16:9",
                mute: false,
                volume: 30
              })
              .setControls(false)
              .on("ready", e => {
                banner.isLoaded = true;
                banner.isPlayerVisible = true;
                if (banner.isPlaying) jwplayer.play();
                banner.isPlaying = true;
                banner.isMuted = jwplayer.getMute();
              })
              .on("play", () => {
                banner.isPlaying = true;
                banner.isPlayerVisible = true;
              })
              .on("pause", () => {
                banner.isPlaying = false;
                banner.isHovered = true;
              })
              .on("complete", () => {
                banner.isHovered = true;
                banner.isPlayerVisible = false;
                banner.isPlaying = false;
              });

            this.players[banner.playerIndex] = jwplayer;

            // Si es el primer video, reproducir.
            if (this.cursos[0].id == banner.id) {
              setTimeout(() => {
                this.players[banner.playerIndex].play();
                banner.isPlaying = true;
              }, 500);
            }
          })
          .catch(error => console.log("ERROR EMBED HOME", error));
      }
    },
    /**
     * Pasa por los cursos y agrega videos a la lista de players.
     */
    loadcursos() {
      this.videosLoaded = true;
      let playersCount = 0;

      if (
        typeof this.curso.fuente_video !== "undefined" &&
        this.curso.fuente_video.length > 0
      ) {
        this.cursos.push({
          ...this.curso,
          playerIndex: Number(playersCount),
          isLoaded: false,
          isPlaying: false,
          isHovered: true,
          isPlayerVisible: false,
          isMuted: true
        });
        let index = this.cursos.length - 1;
        this.$nextTick(() => {
          this.loadPlayer(this.cursos[index]);
        });
        playersCount++;
      } else {
        this.cursos.push({
          ...this.curso,
          playerIndex: false,
          isLoaded: false,
          isPlaying: false,
          isHovered: true
        });
      }
    },
    /**
     * Reproducir el video si no se está reproduciendo, mostrar el título y ocultarlo a los 3 segundos.
     */
    checkVideoPlay(current, next) {
      if (
        this.cursos[current].playerIndex !== false &&
        this.players[this.cursos[current].playerIndex].getState() == "playing"
      )
        this.pauseVideo(current);

      let banner = this.cursos[next];
      banner.isHovered = true;
      if (banner.playerIndex !== false) {
        if (banner.isLoaded) {
          this.players[banner.playerIndex].play();
          wait(() => {
            banner.isHovered = false;
          }, 3000);
        } else {
          banner.isPlaying = true;
        }
      }
    },
    /**
     * Pausa (o reanuda) video.
     */
    pauseVideo(index, tap, $event) {
      console.log("pausing", index, tap, $event);
      if (this.cursos[index].playerIndex !== false) {
        let player = this.players[this.cursos[index].playerIndex];
        if (player.getState() == "playing") player.pause();

        if (["idle", "paused"].includes(player.getState())) {
          player.play();
          this.$set(this.cursos, "isPlaying", true);
          this.$set(this.cursos, "isPlayerVisible", true);
          if (tap) {
            setTimeout(() => {
              this.$set(this.cursos, "isHovered", false);
            }, 1000);
          }
        }
      }
    },
    /**
     * Muestra / oculta info del video.
     */
    toggleHover(curso, toggle, delay) {
      // Ignorar si no tiene video
      if (curso.playerIndex !== false)
        setTimeout(() => {
          curso.isHovered = toggle;
        }, delay || 0);
    },
    getVideoSize(banner, initialWidthHeight) {
      let width = document.querySelector("#container-video-" + banner.id)
        .clientWidth;
      let height =
        (width * initialWidthHeight.height) / initialWidthHeight.width;
      return {
        width,
        height
      };
    },
    resizeVideos() {
      this.cursos.forEach(banner => {});
    },
    toggleMute(banner) {
      if (banner.playerIndex !== false) {
        this.players[banner.playerIndex].setMute(!banner.isMuted);
        banner.isMuted = !banner.isMuted;
      }
    },
    replay(banner) {
      if (banner.playerIndex !== false && banner.isLoaded) {
        this.players[banner.playerIndex].seek(0).play();
        setTimeout(() => {
          banner.isHovered = false;
        }, 1000);
      }
    },
    getPorcentajeProgreso(video) {
      let progreso = getProgresoVideo(this.user, video.id);
      if (progreso == Math.floor(parseFloat(video.video_duracion))) return 100;
      else
        return Math.floor(
          (getProgresoVideo(this.user, video.id) * 100) /
            parseInt(video.video_duracion)
        );
    },
    formatCurrency(price) {
      return numeral(price).format("$0,0");
    },
    comprar() {
      if (this.productoAsociado)
        dataLayer.push({
          event: "boton-comprar"
        });

      //AGREGAR AL CARRO
      dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: "CL",
          add: {
            // 'add' actionFieldObject measures.
            products: [
              {
                //  adding a product to a shopping cart.
                name: this.productoAsociado.producto,
                id: this.productoAsociado.id,
                price: this.productoAsociado.precio,
                category: this.curso.categoria,
                quantity: 1
              }
            ]
          }
        }
      });

      this.$router.push({
        name: "checkout",
        params: {
          id: this.productoAsociado.id,
          curso: this.curso.guid
        }
      });
    },
    regalar() {
      if (this.productoAsociado)
        dataLayer.push({
          event: "boton-comprar"
        });

      //AGREGAR AL CARRO
      dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: "CL",
          add: {
            // 'add' actionFieldObject measures.
            products: [
              {
                //  adding a product to a shopping cart.
                name: this.productoAsociado.producto,
                id: this.productoAsociado.id,
                price: this.productoAsociado.precio,
                category: this.curso.categoria,
                quantity: 1
              }
            ]
          }
        }
      });

      this.$router.push({
        name: "checkout",
        params: {
          id: this.productoAsociado.id,
          curso: this.curso.guid
        },
        query: { regalo: "1" }
      });
    },
    loadAllAccessVideos(contenidos) {
      // Si es Prime, asignar todos los videos al la lista de videos.
      let videos = [];
      if (this.user.all_access_active == 1) {
        // Buscar los videos que no estén aún en la lista de videos.
        contenidos.forEach(contenido => {
          contenido.contenidos_videos.forEach(video => {
            if (this.user.videos.filter(v => v.id == video.id).length == 0)
              videos.push(video);
          });
        });
      }
      // Asignar los nuevos.
      this.$store.commit("setUserVideos", {
        videos: [...this.user.videos].concat(videos)
      });
      this.didLoadContenidos = true;
    },
    loadContenidos() {
      this.isLoadingContenido = true;
      if (this.curso.id != 0)
        this.$store
          .dispatch("getCategoriaContenido", this.curso.id)
          .then(response => {
            this.didLoadContenidos = true;
            this.loadAllAccessVideos(response);
            if (this.curso.contenidos.length > 0) {
              this.claseVisible = this.curso.contenidos[0];
            }
          })
          .catch(error => {
            // TODO: manejar
            console.log({ error });
            this.isLoadingContenido = false;
          });
    },
    getTipoProgreso() {
      let todos = true;
      let tipo = "Comenzar";
      let primero = null;
      let siguiente = null;
      let contenidos = null;
      this.curso.contenidos.forEach(contenido => {
        contenido.contenidos_videos.forEach(video => {
          let progreso = this.getPorcentajeProgreso(video);
          if (primero == null) {
            primero = video;
            contenidos = contenido;
          }
          if (siguiente == null && progreso < 100) {
            siguiente = video;
            contenidos = contenido;
          }
          if (progreso < 100) todos = false;
          if (progreso < 100 && tipo == "Comenzar") tipo = "Continuar";
        });
      });
      if (todos) {
        tipo = "Volver a ver";
        siguiente = primero;
      }

      return {
        tipo,
        siguiente,
        contenidos
      };
    },

    numeroIntervalo(posicion_video_contenido) {
      if (posicion_video_contenido >= 1 && posicion_video_contenido <= 9) {
        return "0" + posicion_video_contenido;
      } else {
        return posicion_video_contenido;
      }
    },
    nextVideo() {
      let next = this.getTipoProgreso();
      this.$router.push({
        name: "video",
        params: {
          guid_categoria: this.curso.guid,
          id_video: next.siguiente.id,
          guid_contenido: next.contenidos.guid,
          id_p_video: this.numeroIntervalo(next.siguiente.posicion),
          id_p_contenido: this.numeroIntervalo(next.contenidos.posicion)
        }
      });
    }
  },
  created() {
    this.players = [];
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Cargar contenidos de curso.
      vm.loadContenidos();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // console.log("beforeRouteUpdate", to);
    next();
  },
  mounted() {
    console.log("tipoprogreso", this.getTipoProgreso());

    // Si ya el portal está cargado y se cargaron los videos, cargar los players.
    if (this.isPortalReady && !this.videosLoaded) this.loadcursos();

    window.addEventListener("resize", this.resizeVideos);

    document.head.querySelector(
      "meta[name=description]"
    ).content = this.curso.descripcion;

    this.loadContenidos();

    let postData = {
      event: "Curso " + this.portal.nombre,
      curso: "Curso " + this.curso.autor
    };
    this.$store.dispatch("eventKlaviyo", postData).then(response => {});
  }
};
</script>
